import { Modal } from 'antd';
import { useCallback } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { QUERY_LIST_CONTAINER_TYPES } from 'queries/DictionariesQueries';
import {
  PURE_QUERY_LIST_CONTAINERS,
  MUTATION_ASSIGN_TYPE_TO_CONTAINERS,
} from '../queries';

export default function AssignContainerTypeConfirmModal({
  open,
  onClose,
  containerIds,
  nextContainerTypeId,
}: {
  open: boolean;
  onClose: () => void;
  containerIds?: number[];
  nextContainerTypeId?: number;
}) {
  const { data: containerTypes } = useQuery(QUERY_LIST_CONTAINER_TYPES);
  const [assignContainerTypeToContainers, { loading }] = useMutation(
    MUTATION_ASSIGN_TYPE_TO_CONTAINERS,
    {
      refetchQueries: [PURE_QUERY_LIST_CONTAINERS],
    },
  );

  const handleOk = useCallback(async () => {
    await assignContainerTypeToContainers({
      variables: {
        type_id: nextContainerTypeId,
        container_ids: containerIds,
      },
    });

    onClose();
  }, [containerIds, nextContainerTypeId]);

  const containerTypeName = containerTypes?.listContainerType?.find(
    (ct: { type_id: number }) => ct.type_id === nextContainerTypeId,
  )?.name;

  return (
    <Modal
      title="Set Container Type"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={loading}
    >
      <p>
        Assign <b>{containerIds?.length}</b>{' '}
        {containerIds && containerIds?.length > 1 ? 'containers' : 'container'}{' '}
        to&nbsp;
        <b>{containerTypeName}</b> container type?
      </p>
    </Modal>
  );
}
